
<rdo-maintenance-window>
  <main [hidden]="!isLoaded()" rdoClientBrandingStyling>
    <app-competitive-disclaimer-dialog />
    <div id="app-div" class="app-root app-root-md md platform-core enable-hover">
          <div id="current-tab" class="tabs tabs-md" >
            <app-nav/>
            <router-outlet/>
            <app-tab-bar/>
          </div>
    </div>
  </main>
</rdo-maintenance-window>
